import fileDownload from 'js-file-download'

import { jsToFormData, paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Csv, PaginatedResponse, Sku, SkuByFacility } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export interface ExportProps {
  fields: string[]
}
interface UploadCSVProps {
  guid: string
  config: CustomAxiosConfig
}

export interface Stats {
  // eslint-disable-next-line camelcase
  total_ordered: number
  // eslint-disable-next-line camelcase
  total_received: number
  // eslint-disable-next-line camelcase
  total_shipped: number
}

export class Skus {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Sku>> => {
    const response = await this.api.get('/logistics/skus', config)
    return paginatedTransform(Sku)(response.data)
  }

  byFacility = async (
    guid: string,
    config: CustomAxiosConfig = {}
  ): Promise<PaginatedResponse<Sku>> => {
    const response = await this.api.get(`/logistics/skus/${guid}/by-facility`, config)
    return paginatedTransform(SkuByFacility)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Sku> => {
    const response = await this.api.get(`/logistics/skus/${guid}`, config)
    return rawTransform(Sku)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: '/logistics/skus/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'skus.csv')
  }

  uploadCsvSkus = async ({ guid, config = {} }: UploadCSVProps): Promise<any> => {
    const axiosConfig = {
      ...config,
      method: 'post' as 'post',
      url: `/logistics/skus/csv/clients/${guid}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: jsToFormData(config?.data),
      customTransform: rawTransform(Csv),
    }
    return await this.api.axiosInstance(axiosConfig)
  }

  stats = async (guid: string, config: CustomAxiosConfig = {}): Promise<Stats> => {
    const response = await this.api.get(`/logistics/skus/${guid}/in-out-stats`, config)
    return response.data
  }
}
